import { Service } from '../../types/api';

interface ServiceCardProps {
  service: Service;
  serverId: number;
  isSelected?: boolean;
  onSelect: (service: Service) => void;
}

export function ServiceCard({
  service,
  serverId: _serverId,
  isSelected,
  onSelect,
}: ServiceCardProps) {
  const getServicePrice = (): number | null => {
    if ('price' in service && typeof service.price === 'number') {
      return service.price;
    }
    return null;
  };

  const serviceName = 'name' in service && typeof service.name === 'string' ? service.name : 'Unknown Service';
  const price = getServicePrice();
  const logoUrl = '/logos/defo.jpg';

  return (
    <button
      onClick={() => onSelect(service)}
      className={`w-full bg-neutral-dark/50 backdrop-blur-sm border rounded-lg p-4 hover:shadow-lg transition-all duration-300 text-left group ${
        isSelected
          ? 'border-brand-accent shadow-brand-accent/20 scale-105'
          : 'border-neutral-dark hover:border-brand-accent/50 hover:shadow-brand-accent/20 hover:scale-105'
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-neutral-dark/80 flex items-center justify-center overflow-hidden shrink-0">
            <img
              src={logoUrl}
              alt=""
              loading="lazy"
              className="w-8 h-8 object-contain"
            />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-heading font-semibold text-neutral-light group-hover:text-brand-accent transition-colors truncate">
              {serviceName}
            </h3>
            {price !== null && (
              <p className="text-sm text-neutral-medium font-body">
                {price.toFixed(2)} USD
              </p>
            )}
          </div>
        </div>
        {isSelected && (
          <div className="ml-2">
            <div className="w-6 h-6 rounded-full bg-brand-accent flex items-center justify-center">
              <svg
                className="w-4 h-4 text-brand-primary"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>
        )}
      </div>
    </button>
  );
}

